import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {dischargeGrants} from 'src/openapi/admin/apis/BulkDischargePresetGrantsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {Error} from 'src/openapi/admin/models/Error';
import type {SuccessPayload} from 'src/typedef';

type ActionProps = {
    presetId: string,
    updateReason?: string,
};

export const useDischargeGrantsFromPreset = (grantIds: string[]) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(async (props?: ActionProps) => {
        if (!props?.presetId) {
            const payload: {success: false, error: true, data: Error} = {
                success: false,
                error: true,
                data: {message: 'Preset ID is required'},
            };
            return Promise.resolve({type: '', payload});
        }

        const {presetId, updateReason} = props;
        const assignRolesResponse = await apiDispatch(dischargeGrants({
            dischargeGrantsRequest: {presetId, grants: grantIds, updateReason},
        }));

        if (assignRolesResponse.payload.success) {
            const payload: SuccessPayload<undefined> = {
                success: true,
                error: false,
                data: undefined,
            };
            return Promise.resolve({type: '', payload});
        } else {
            return Promise.resolve({type: '', payload: assignRolesResponse.payload});
        }
    }, [grantIds, apiDispatch]);

    return useCommonEventHook({eventAction});
};
